import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, freddyTheme, Typography } from '@coolblue-development/freddy';
export const CategoryNavigationBarGroup = ({ onMouseOver, isActive, group, }) => (_jsx(Flex, { tabIndex: 0, onMouseOver: onMouseOver, alignItems: "center", component: "li", p: `${freddyTheme.spacing[400]} 0 1.3rem`, sx: {
        position: 'relative',
        listStyleType: 'none',
        borderBottom: `${freddyTheme.borderWidth[75]} solid ${isActive ? freddyTheme.color.border.secondary : 'transparent'}`,
        transition: 'border-bottom 150ms ease-in-out',
    }, children: _jsx(Typography, { color: "interactiveBase", fontWeight: 600, textAlign: "center", children: group.title }) }));
//# sourceMappingURL=CategoryNavigationBarGroup.js.map